import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dmsToDecimal' })
export class DmsToDecimalPipe implements PipeTransform {
  transform(dms: string): string {
    if (!dms) return null;

    // Example: 84-25-40.3104W
    const match = dms.match(/^(\d+)-(\d+)-([\d.]+)([NSEW])$/);
    if (!match) return null;

    const deg = Number(match[1]);
    const min = Number(match[2]);
    const sec = Number(match[3]);
    const hemi = match[4];

    let dec = deg + min / 60 + sec / 3600;

    if (hemi === 'S' || hemi === 'W') {
      dec *= -1;
    }

    return dec.toString();
  }
}


/** WEBPACK FOOTER **
 ** ./app/airports/dms-to-degrees.pipe.ts
 **/